export default __webpack_public_path__ + "static/media/paypals.55cf3310.png";